import { useSelector, shallowEqual } from 'react-redux';
import { selectConsumptionType } from 'state/consumption-entry/consumption-entry-slice';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { usePartner } from 'components/app/routes/usePartner';
import { useConsumption } from 'hooks/useConsumption';
import { PARTNERS, CONSUMPTION_TYPES, FUEL_TYPES } from 'config/app-config';
import { useEnergyUsage } from 'hooks/useEnergyUsage';

export const useConsumptionEntry = () => {
  const getEnergyUsage = useEnergyUsage();
  const { activePartner } = usePartner();
  const consumptionType = useSelector(selectConsumptionType, shallowEqual);
  const selectedFuelType = useSelector(selectFuelType, shallowEqual);
  const energyUsage = getEnergyUsage(CONSUMPTION_TYPES.HIGH, selectedFuelType);
  const { consumption } = useConsumption();

  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];
  const isActual = consumptionType === CONSUMPTION_TYPES.ACTUAL;
  const isEnergyUsageExceeds =
    !!(
      selectedFuelType[FUEL_TYPES.GAS] &&
      (consumption[FUEL_TYPES.GAS] ?? 0) > energyUsage[FUEL_TYPES.GAS]
    ) ||
    !!(
      selectedFuelType[FUEL_TYPES.ELECTRIC] &&
      (consumption?.[FUEL_TYPES.ELECTRIC] ?? 0) >
        energyUsage[FUEL_TYPES.ELECTRIC]
    );

  return {
    consumptionType,
    isMoveInJourney,
    isActual,
    isEnergyUsageExceeds
  };
};
